import { render, staticRenderFns } from "./card4.vue?vue&type=template&id=18bbcdb6&scoped=true&"
import script from "./card4.vue?vue&type=script&lang=js&"
export * from "./card4.vue?vue&type=script&lang=js&"
import style0 from "./card4.vue?vue&type=style&index=0&id=18bbcdb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bbcdb6",
  null
  
)

export default component.exports